import { ServerApi } from 'modules/api/server-api';

import { decodeCompanyUser } from '@/models/CompanyUser';

export const fetchCompanyUsers = (api: ServerApi) => async () => {
  const response = await api.get('/company/users');
  return response.data.users.map(decodeCompanyUser);
};
